/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_RENTAL_RECEIVE,
    CURRENT_RENTAL_REQUEST,
    CURRENT_RENTAL_REQUEST_SUCCESS,
    CURRENT_RENTAL_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_RENTAL_REQUEST]: () => true,
    [CURRENT_RENTAL_REQUEST_SUCCESS]: () => false,
    [CURRENT_RENTAL_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_RENTAL_RECEIVE]: (state, action) => action.payload.rental,
});

export const error = createReducer(false, {
    [CURRENT_RENTAL_REQUEST]: () => false,
    [CURRENT_RENTAL_REQUEST_SUCCESS]: () => false,
    [CURRENT_RENTAL_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
